import React, { useState, useEffect} from 'react';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { TabContent, TabPane, Nav, NavItem, NavLink, FormGroup, Label, Row, Col, Input, InputGroupAddon, Button } from 'reactstrap';
import { TagsField, TranslatableField, MoneyField, PercentageField, RolesField, TickettypesField, WysiwygField, RefField } from '../../components';
import { Utils } from '../../services';
import classnames from 'classnames';
import HelpTooltips from '../HelpTooltips/HelpTooltips';
import AdditionnalClassesField from '../AdditionnalClassesField';
import './BrickForm.css';

const BrickForm = ({ workflow, brick, isLoading, smallCard }) => {
    const { t }                     = useTranslation();
    const currency                  = Utils.currency();
    const [activeTab, setActiveTab] = useState('options');
    const { linkedResources } = useSelector(state => state.workflows);

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const optionsProps = { workflow, t, ...linkedResources };

    const inputMappingField = (position, input) => {
        if (position === 0 || !workflow?.bricks?.length)
            return null;

        const options = {};
        workflow.bricks.forEach(brick => {
            if (brick.position >= position)
                return;

            brick.outputs.forEach(output => {
                options[output] = true;
            });
        });
        if (!Object.keys(options).length)
            return null;

        return (
            <Field component="select" className="form-control" type="text" name={`bricks[${position}].inputs_mapping.${input}`}>
                <option value="">-</option>
                {Object.keys(options).map(output => (
                    <option key={ output } value={output}>
                        { output }
                    </option>
                ))}
            </Field>
        );
    }

    return (
        <div className='BrickForm'>
            <Nav tabs>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === 'options' })} onClick={() => { toggle('options'); }}>
                        {t('workflows.bricks.options')}
                    </NavLink>
                </NavItem>
                {brick?.inputs?.length > 0 && (
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === 'inputs_mapping' })} onClick={() => { toggle('inputs_mapping'); }}>
                            {t('workflows.bricks.inputs_mapping')}
                        </NavLink>
                    </NavItem>
                )}
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane className='border-bottom border-right border-left' tabId="options">
                    <br />
                    { brick.getOptionsForm(optionsProps) }
                </TabPane>
                <TabPane tabId="inputs_mapping">
                    <br />
                    { brick?.inputs?.map(input => (
                        <FormGroup key={ input } row>
                            <Label for={input} sm={4}>
                                { input }
                            </Label>
                            <Col sm={smallCard ? 8 : 12}>
                                { inputMappingField(brick.position, input) }
                            </Col>
                        </FormGroup>
                    ))}
                </TabPane>
            </TabContent>
        </div>
    );
}

export default BrickForm;
